import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

/**
 * Generated class for the AddorderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
	selector: "page-inventory",
	templateUrl: "inventory.html"
})
export class InventoryPage {
	constructor(public navCtrl: NavController, public navParams: NavParams) {}

	ionViewDidLoad() {
		console.log("ionViewDidLoad InventoryPage");
	}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventory.ts